import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { REGISTER } from 'app/model/register.model';
import { FormGroup } from '@angular/forms';
import { RegisterService } from 'app/services/register/register.service';
import { CookieService } from 'ngx-cookie';
import { debug } from 'util';

@Component({
  selector: 'confirmdialog',
  templateUrl: './confirmdialog.component.html',
  styleUrls: ['./confirmdialog.component.scss']
})
export class ConfirmdialogComponent implements OnInit {
  //* style

  displays: string = 'none';

  @Input() visible: boolean = false;

  @Output() destrop: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() success: EventEmitter<string> = new EventEmitter<string>();

  @Input() formdata: FormGroup;

  @Input() resellerCode: string = '';

  /**
   * if choice is true, means user is going to submit data,
   * if choice is false, means user is going to save data,
   */
  @Input() choice: string;

  email: string = '';

  resellerID: string = 'null';

  //email to :

  public tAu = 'mailto:accounts@dickerdata.com.au?Subject=Dicker Data Reseller Application Id -';

  public tNz = 'mailto:accounts@dickerdata.co.nz?Subject=Dicker Data Reseller Application Id - ';

  constructor(
    private registerService: RegisterService,
    private cookieService: CookieService
  ) {}

  ngOnInit() {
    document.body.style.overflow = 'hidden';
    if (this.choice == 'true') {
      this.save(true);
    }
  }

  web() {
    // console.log(window.location.href.indexOf(".co.nz"));
    return window.location.href.indexOf('.co.nz');
    // return 1;
  }

  preventClick(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  emailSent: boolean = false;
  save(sendEmail: boolean) {
    if (sendEmail) {
      this.emailSent = true;
    } else {
      this.emailSent = false;
    }

    if (this.resellerID != 'null') {
      return;
    }
    //console.log("this.emaiL: ", this.email);
    if (this.choice != 'false') {
      //submit data
      this.email =
        this.web() > 0
          ? 'accounts@dickerdata.co.nz'
          : 'accounts@dickerdata.com.au';
      console.log(this.resellerCode);
      // debugger;
      this.registerService
        .submitform(this.formdata, this.resellerCode, this.email)
        .subscribe(
          (result: returnInfor) => {
            //console.log('get the result');
            this.resellerID = result.mdcode.toString();
            this.tAu += this.resellerID;
            this.tNz += this.resellerID;
            this.success.emit(result.in_reseller_accountcode);
            //then save data into the cookies
            this.cookieService.removeAll();

            let form: REGISTER = <REGISTER>this.formdata.value;

            let businessGroup = form.businessGroup;
            let deliverMethodArray = form.deliverMethodArray;
            let ownerinfoArray = form.ownerinfoArray;
            let marketinfo = form.marketinfo;
            let businessRefArray = form.businessRefArray;
            let financialGroup = form.financialGroup;
            let privacyGroup = form.privacyGroup;
            let declarationGroup = form.declarationGroup;
            let guaranteeGroup = form.guaranteeGroup;

            this.cookieService.putObject('form', 'true');
            this.cookieService.putObject('businessGroup', businessGroup);
            this.cookieService.putObject(
              'deliverMethodArray',
              deliverMethodArray
            );
            this.cookieService.putObject('ownerinfoArray', ownerinfoArray);
            this.cookieService.putObject('marketinfo', marketinfo);
            this.cookieService.putObject('businessRefArray', businessRefArray);
            this.cookieService.putObject('financialGroup', financialGroup);
            this.cookieService.putObject('privacyGroup', privacyGroup);
            this.cookieService.putObject('declarationGroup', declarationGroup);
            this.cookieService.putObject('guaranteeGroup', guaranteeGroup);
          },
          error => {
            //TODO:

            // businessGroup: BUSINESSGROUP;
            // deliverMethodArray:DELIVERYMETHODARRAY[];
            // ownerinfoArray: OWNERINFO[];
            // marketinfo:MARKETINFO;
            // businessRefArray: BUSINESSREF[];
            // financialGroup:FINANCIALGROUP;
            // privacyGroup:PRIVACY;
            // declarationGroup:DECLARATIONGROUP;
            // guaranteeGroup:GUARANTEEGROUP;
            this.cookieService.removeAll();

            let form: REGISTER = <REGISTER>this.formdata.value;

            let businessGroup = form.businessGroup;
            let deliverMethodArray = form.deliverMethodArray;
            let ownerinfoArray = form.ownerinfoArray;
            let marketinfo = form.marketinfo;
            let businessRefArray = form.businessRefArray;
            let financialGroup = form.financialGroup;
            let privacyGroup = form.privacyGroup;
            let declarationGroup = form.declarationGroup;
            let guaranteeGroup = form.guaranteeGroup;

            this.cookieService.putObject('form', 'true');
            this.cookieService.putObject('businessGroup', businessGroup);
            this.cookieService.putObject(
              'deliverMethodArray',
              deliverMethodArray
            );
            this.cookieService.putObject('ownerinfoArray', ownerinfoArray);
            this.cookieService.putObject('marketinfo', marketinfo);
            this.cookieService.putObject('businessRefArray', businessRefArray);
            this.cookieService.putObject('financialGroup', financialGroup);
            this.cookieService.putObject('privacyGroup', privacyGroup);
            this.cookieService.putObject('declarationGroup', declarationGroup);
            this.cookieService.putObject('guaranteeGroup', guaranteeGroup);
          }
        );
    } else {
      //save data
      // console.log("do I come inside?");
      console.log('--->', this.resellerCode);
      // debugger;
      this.registerService
        .submitform(this.formdata, this.resellerCode, this.email)
        .subscribe(
          (result: returnInfor) => {
            // console.log(result);
            // this.resellerID = result.toString();
            // this.success.emit(this.resellerID);

            this.resellerID = result.mdcode.toString();
            this.success.emit(result.in_reseller_accountcode);

            //then save data into the cookies
            this.cookieService.removeAll();

            let form: REGISTER = <REGISTER>this.formdata.value;

            let businessGroup = form.businessGroup;
            let deliverMethodArray = form.deliverMethodArray;
            let ownerinfoArray = form.ownerinfoArray;
            let marketinfo = form.marketinfo;
            let businessRefArray = form.businessRefArray;
            let financialGroup = form.financialGroup;
            let privacyGroup = form.privacyGroup;
            let declarationGroup = form.declarationGroup;
            let guaranteeGroup = form.guaranteeGroup;

            this.cookieService.putObject('form', 'true');
            this.cookieService.putObject('businessGroup', businessGroup);
            this.cookieService.putObject(
              'deliverMethodArray',
              deliverMethodArray
            );
            this.cookieService.putObject('ownerinfoArray', ownerinfoArray);
            this.cookieService.putObject('marketinfo', marketinfo);
            this.cookieService.putObject('businessRefArray', businessRefArray);
            this.cookieService.putObject('financialGroup', financialGroup);
            this.cookieService.putObject('privacyGroup', privacyGroup);
            this.cookieService.putObject('declarationGroup', declarationGroup);
            this.cookieService.putObject('guaranteeGroup', guaranteeGroup);
          },
          error => {
            // console.log("has error: ", error);
            //TODO:

            // businessGroup: BUSINESSGROUP;
            // deliverMethodArray:DELIVERYMETHODARRAY[];
            // ownerinfoArray: OWNERINFO[];
            // marketinfo:MARKETINFO;
            // businessRefArray: BUSINESSREF[];
            // financialGroup:FINANCIALGROUP;
            // privacyGroup:PRIVACY;
            // declarationGroup:DECLARATIONGROUP;
            // guaranteeGroup:GUARANTEEGROUP;
            this.cookieService.removeAll();

            let form: REGISTER = <REGISTER>this.formdata.value;

            let businessGroup = form.businessGroup;
            let deliverMethodArray = form.deliverMethodArray;
            let ownerinfoArray = form.ownerinfoArray;
            let marketinfo = form.marketinfo;
            let businessRefArray = form.businessRefArray;
            let financialGroup = form.financialGroup;
            let privacyGroup = form.privacyGroup;
            let declarationGroup = form.declarationGroup;
            let guaranteeGroup = form.guaranteeGroup;

            this.cookieService.putObject('form', 'true');
            this.cookieService.putObject('businessGroup', businessGroup);
            this.cookieService.putObject(
              'deliverMethodArray',
              deliverMethodArray
            );
            this.cookieService.putObject('ownerinfoArray', ownerinfoArray);
            this.cookieService.putObject('marketinfo', marketinfo);
            this.cookieService.putObject('businessRefArray', businessRefArray);
            this.cookieService.putObject('financialGroup', financialGroup);
            this.cookieService.putObject('privacyGroup', privacyGroup);
            this.cookieService.putObject('declarationGroup', declarationGroup);
            this.cookieService.putObject('guaranteeGroup', guaranteeGroup);
          }
        );
    }

    /**
     * 下面关闭的这个功能后期要导入到其他的方法中去
     */
  }

  closePop() {
    document.body.style.overflow = 'auto';
    this.destrop.emit(false);
    // console.log(this.formdata.value);
    this.visible = false;
    event.preventDefault();
    event.stopPropagation();
  }
}

export interface returnInfor {
  mdcode: string;
  in_reseller_accountcode: string;
}



// WEBPACK FOOTER //
// ./src/app/register/confirmdialog/confirmdialog.component.ts